import { useNavigate } from "react-router-dom";
import { useState } from "react";
import NavbarIconButton from "./NavbarIconButton";
import HamburgerButton from "../../fragments/hamburgher-button/HamburgerButton";
import logo from "../../core/header-component/logo.png";
import exit from "../assets/exit.svg";
import product from "../assets/product.svg";
import gear from "../assets/gear.svg";
import gearInactive from "../assets/gear-gray.svg";
import document from "../assets/document.svg";
import productInactive from "../assets/product-gray.svg";
import documentInactive from "../assets/document-gray.svg";

export default function DashNavbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [activeButton, setActiveButton] = useState(null);

  const navigate = useNavigate();

  const handleButtonClick = (index, path, withActive = true) => {
    if (withActive) {
      setActiveButton(index);
    }
    setIsOpen(false);
    if (path) {
      setTimeout(() => navigate(path), 1);
    }
  };

  return (
    <>
      <div className={`${isOpen ? "dash-overlay" : ""}`} />
      <div
        className={`${
          isOpen ? "dash-component__header-open" : "dash-component__header-close"
        } shadow-drop-2-bottom`}
      >
        <div className="dash-component__header-btn">
          <HamburgerButton
            isOpen={isOpen}
            noExtraClass
            onClick={() => setIsOpen(!isOpen)}
          />
        </div>

        {isOpen && (
          <>
            <span className="header-span" />

            <div className="dash-component__navbar-top">
              <NavbarIconButton
                icon={activeButton === 0 ? document : documentInactive}
                alt="Fatture"
                isActive={activeButton === 0}
                onClick={() => handleButtonClick(0, "/dashboard/invoices")}
              />
              <NavbarIconButton
                icon={activeButton === 1 ? product : productInactive}
                alt="Dati"
                isActive={activeButton === 1}
                onClick={() => handleButtonClick(1, "/dashboard/inventory")}
              />
            </div>

            <div className="dash-component__navbar-footer">
              <NavbarIconButton
                icon={activeButton === 3 ? gear : gearInactive}
                alt="Impostazioni"
                isActive={activeButton === 3} // sempre neutro
                onClick={() => handleButtonClick(3, "/dashboard/settings")}
              />
              <NavbarIconButton
                icon={exit}
                alt="Logout"
                isActive={false} // sempre neutro
                onClick={() => handleButtonClick(3, null, false)}
              />
            </div>

            <div className="logo logo-dash">
              <img
                src={logo}
                width="90"
                height="100"
                alt="Logo"
                onClick={() => handleButtonClick(null, "/dashboard")}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
}
